const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-wells/shared/styles/CommonStyle");